module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('p', {
    staticClass: "c12"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('strong', {
    staticClass: "calibre1"
  }, [_vm._v("CUE-TITLES")])]), _vm._v(" "), _c('p', {
    staticClass: "c24"
  }, [_c('strong', {
    staticClass: "calibre1"
  }, [_vm._v("A. Manuscript locations")])]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "c19",
    staticStyle: {
      "width": "100%",
      "font-size": "1em"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "t348_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c25",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("GSArchiv")]), _vm._v(" "), _c('td', {
    staticClass: "c26",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Goethe-und Schiller-Archiv, Weimar")])]), _vm._v(" "), _c('tr', {
    staticClass: "t348_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Lazarus")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Mr George Lazarus")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t348_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("NWU")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Northwestern University")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t348_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("UCB")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("University of California at Berkeley")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t348_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("UCLA")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("University of California at Los Angeles")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t348_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("UNM")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("University of New Mexico")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t348_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("UT")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("University of Texas at Austin")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t348_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("UTul")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("University of Tulsa")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t348_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("YU")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Yale University")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "c24"
  }, [_c('strong', {
    staticClass: "calibre1"
  }, [_vm._v("B. Printed works")])]), _vm._v(" "), _c('p', {
    staticClass: "c27"
  }, [_vm._v("(The place of publication, here and throughout, is London unless otherwise stated.)")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "c19",
    staticStyle: {
      "width": "100%",
      "font-size": "1em"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "t351_firstrow",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c25",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Aaron's Rod")])]), _vm._v(" "), _c('td', {
    staticClass: "c26",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("D. H. Lawrence. "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Aaron's Rod")]), _vm._v(". Ed. Mara Kalnins. Cambridge: Cambridge University Press, 1988.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t351_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Dennis")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("George Dennis. "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("The Cities and Cemeteries of Etruria")]), _vm._v(". 2nd edn. 2 volumes. J. Murray, 1878.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t351_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Ducati")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Pericle Ducati. "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Etruria Antica")]), _vm._v(". 2 volumes. Torino: G. B. Paravia, 1925.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t351_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Letters")]), _vm._v(", iii.")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("James T. Boulton and Andrew Robertson, eds. "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("The Letters of D. H. Lawrence")]), _vm._v(". Volume III. Cambridge: Cambridge University Press, 1984.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t351_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Letters")]), _vm._v(", v.")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("James T. Boulton and Lindeth Vasey, eds. "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("The Letters of D. H. Lawrence")]), _vm._v(". Volume V. Cambridge: Cambridge University Press, 1989.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t351_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Letters")]), _vm._v(", vi.")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("James T. Boulton and Margaret H. Boulton with Gerald M. Lacy, eds. "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("The Letters of D. H. Lawrence")]), _vm._v(". Volume VI. Cambridge: Cambridge University Press, 1991.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t351_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "page_xvii"
    }
  }), _vm._v("OED")])]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Sir James A. H. Murray and others, eds"), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v(". A New English Dictionary on Historical Principles")]), _vm._v(". 10 volumes. Oxford University Press, 1884–1928.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t351_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Phoenix")])]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Edward D. McDonald, ed. "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Phoenix: The Posthumous Papers of D.H. Lawrence")]), _vm._v(". New York: Viking Press, 1936.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t351_lastrow",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Roberts")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Warren Roberts. "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("A Bibliography of D.H. Lawrence")]), _vm._v(". 2nd edn. Cambridge: Cambridge University Press, 1982.")])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53ac81ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0008.vue
// module id = 84
// module chunks = 0